const DesktopStyle = () => {
    let contentlist = {
        viewStyle: "unset"
    }
    return contentlist;
}

export { DesktopStyle }